import { Suspense, lazy, useContext } from 'react'
import { ThemeContext } from './contexts/theme'
import Header from './components/Header/Header'
import About from './components/About/About'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import Footer from './components/Footer/Footer'
import './App.css'

const ProfessionalExperience = lazy(() =>
  import('./components/ProfessionalExperience/ProfessionalExperience')
)
const Education = lazy(() => import('./components/Education/Education'))
const Skills = lazy(() => import('./components/Skills/Skills'))
const Tools = lazy(() => import('./components/Tools/Tools'))
const Contact = lazy(() => import('./components/Contact/Contact'))
const SxswEventsPage = lazy(() => import('./pages/SxswEventsPage/SxswEventsPage'))

const getCurrentPathname = () => {
  if (typeof window === 'undefined') return '/'
  const trimmedPathname = window.location.pathname.replace(/\/+$/, '')
  return trimmedPathname || '/'
}

const App = () => {
  const [{ themeName }] = useContext(ThemeContext)
  const isSxswPage = getCurrentPathname() === '/sxsw'

  if (isSxswPage) {
    return (
      <div id='top' className={`${themeName} app`}>
        <Suspense fallback={null}>
          <SxswEventsPage />
        </Suspense>
        <ScrollToTop />
        <Footer />
      </div>
    )
  }

  return (
    <div id='top' className={`${themeName} app`}>
      <Header />

      <main>
        <About />
        <Suspense fallback={null}>
          <ProfessionalExperience />
          <Education />
          <Skills />
          <Tools />
          <Contact />
        </Suspense>
      </main>

      <ScrollToTop />
      <Footer />
    </div>
  )
}

export default App
